import { k } from "../kaplay";

import { cards, activeCardIds } from "../data/cards";

import { addCard } from "../gameobjects/card";

import { waveManager } from "./waveManager";

// Game state machine
export function createGameManager(){
  const gameManager = k.add([
    "gameManager",

    k.state("game", ["game", "card"]),
    k.layer("ui"),
    waveManager()
  ])

  function pauseGame(pause){
    const tags = ["player", "attack_enemy", "enemy"];
    for (let tag of tags){
      k.get(tag).forEach((entity) => { entity.paused = pause }); 
    }
  }

  gameManager.onStateEnter("game", () => {
    gameManager.spawning = true;

    const player = k.get("player")[0];
    if (player) player.canCast = true;

    pauseGame(false);
  })

  gameManager.onStateEnter("card", () => {
    gameManager.spawning = false;

    const player = k.get("player")[0];
    if (player) player.canCast = false;
    else return;

    pauseGame(true);

    const cardNumber = 3;
    const cardSpace = 320;

    const availableCards = cards.filter(card =>
      (!card.unique || !activeCardIds.includes(card.id)) &&
      (!card.require || card.require.every(req => activeCardIds.includes(req)))
    );

    for (let i = -1; i < cardNumber - 1; i++){
      const randomCardData = availableCards[Math.floor(Math.random() * availableCards.length)];
      addCard(randomCardData, new k.Vec2(cardSpace * i, 0));
    }
  })

  gameManager.onStateEnd("card", () => {
    k.get("card").forEach((card) => { card.destroy() });
  })

  k.onClick("card", (card) => {
    // console.log(card.card_data)
    card.card_data.choose();
    activeCardIds.push(card.card_data.id);
    const gameManager = k.get("gameManager")[0];
    gameManager.enterState("game");
  })

  return gameManager;
}